import React from "react";

import Section from "./Section";

// Python and PyTorch carry the image-processing work, so they get the accent.
const languages = [
  { label: "Python", core: true },
  { label: "PyTorch", core: true },
  { label: "JavaScript" },
  { label: "Node.js" },
  { label: "React" },
  { label: "Vue.js" },
];

const tools = ["Linux", "VS Code", "PyCharm", "Postman"];

function Skills() {
  return (
    <Section id="skills" label="Skills">
      <div className="space-y-7">
        <div>
          <h3 className="text-base font-medium text-fg mb-3">Languages and frameworks</h3>
          <ul className="flex flex-wrap gap-1.5">
            {languages.map(({ label, core }) => (
              <li
                key={label}
                className={`inline-flex items-center h-7 px-2.5 rounded-md border font-mono text-xs ${
                  core ? "border-leaf/40 bg-leaf/10 text-leaf" : "border-line text-body"
                }`}
              >
                {label}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-base font-medium text-fg mb-3">Tools</h3>
          <ul className="flex flex-wrap gap-1.5">
            {tools.map((tool) => (
              <li
                key={tool}
                className="inline-flex items-center h-7 px-2.5 rounded-md border font-mono text-xs border-line text-body"
              >
                {tool}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Section>
  );
}

export default Skills;
